module.exports = __webpack_public_path__ + "img/logo-14.a8243156.png";